import api from './api';

interface Software {
  id: number;
  name: string;
  created_at: string;
  updated_at: string;
}

interface CreateSoftwareData {
  name: string;
  industry?: number;
}

export const listSoftware = async (industryId?: number): Promise<Software[]> => {
  const url = industryId ? `software/?industry=${industryId}` : `software/`;
  const response = await api.get(url);
  return response.data;
};

export const createSoftware = async (data: CreateSoftwareData): Promise<Software> => {
  const response = await api.post(`software/`, data);
  return response.data;
};

export const updateSoftware = async (id: number, data: Partial<CreateSoftwareData>): Promise<Software> => {
  const response = await api.patch(`software/${id}/`, data);
  return response.data;
};

export const deleteSoftware = async (id: number): Promise<void> => {
  await api.delete(`software/${id}/`);
};